export const services = {
  pageTitle: 'خدماتنا',
  pageSubtitle: 'حلول شاملة لجميع مشاريع التجديد والبناء الخاصة بك في بروكسل',
  
  // Masonry
  masonryTitle: 'البناء والمباني',
  masonryDescription: 'أعمال بناء صلبة ودائمة لتأمين وتثمين عقارك بأعلى معايير الجودة',
  masonryFeature1: 'بناء الجدران الحاملة',
  masonryFeature2: 'إصلاح الواجهات',
  masonryFeature3: 'الأساسات والبلاطات',
  masonryFeature4: 'أعمال الطوب والبناء',
  
  // Bathroom & Kitchen
  bathroomTitle: 'الحمام والمطبخ',
  bathroomDescription: 'مساحات عصرية وعملية وجمالية، مصممة لراحتك اليومية',
  bathroomFeature1: 'تجديد كامل',
  bathroomFeature2: 'تركيب الأدوات الصحية',
  bathroomFeature3: 'البلاط والتغطيات',
  bathroomFeature4: 'تجهيزات مخصصة',
  
  // Painting & Finishes
  paintingTitle: 'الدهان والتشطيبات',
  paintingDescription: 'تشطيبات متقنة تبرز مساحاتك وتضمن نتيجة مثالية مع مرور الوقت',
  paintingFeature1: 'دهان داخلي وخارجي',
  paintingFeature2: 'تحضير الأسطح',
  paintingFeature3: 'تركيب ورق الجدران',
  paintingFeature4: 'تشطيبات ديكورية',
  
  // Partitions & Insulation
  partitionTitle: 'الجدران والعزل',
  partitionDescription: 'عزل فعال لتحسين راحتك الحرارية وتقليل نفقاتك الطاقية',
  partitionFeature1: 'جدران من ألواح الجبس',
  partitionFeature2: 'عزل حراري',
  partitionFeature3: 'عزل صوتي',
  partitionFeature4: 'تهيئة المساحات',
  
  // Carpentry
  carpentryTitle: 'النجارة',
  carpentryDescription: 'تركيب وتجديد الأبواب والنوافذ والتجهيزات المخصصة بحرفية عالية',
  carpentryFeature1: 'أبواب داخلية وخارجية',
  carpentryFeature2: 'نوافذ وإطارات',
  carpentryFeature3: 'باركيه وأرضيات',
  carpentryFeature4: 'تجهيزات مخصصة',
  
  // Electrical
  electricalTitle: 'الكهرباء',
  electricalDescription: 'تركيبات كهربائية متوافقة مع المعايير البلجيكية لسلامتك وراحة بالك',
  electricalFeature1: 'تركيب كهربائي كامل',
  electricalFeature2: 'التحديث حسب المعايير',
  electricalFeature3: 'إضاءة وأتمتة منزلية',
  electricalFeature4: 'صيانة وإصلاح',
  
  // CTA
  ctaTitle: 'هل تحتاج عرض سعر لمشروعك؟',
  ctaDescription: 'اتصل بنا لمناقشة مشروعك والحصول على عرض سعر مجاني ومخصص',
  ctaButton: 'اطلب عرض سعر مجاني'
};